import { useEffect, useState } from 'react';

const DELAY = 50;

// This is only used to skip render filters in Litter and Breeder List
// A trick to increase INP as the filters are not needed right away
export const useSkipOnFirstRender = () => {
  const [canRender, setCanRender] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setCanRender(true);
    }, DELAY);
  }, []);

  return canRender;
};
